import { MutableRememberyv35kz5kmml7 as MutableRemember } from './MutableRemember.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { remember2m0mx1b5ra75q as remember } from './Remember.mjs';
import { awaitOnce3bs0u39jtmrli as awaitOnce } from '../context/DependencyChangeListener.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  MutableReactive2qdhhyljdknhy as MutableReactive,
  MutableValue2jbqb2a7km3rc as MutableValue,
} from './coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Draft(published) {
  return BaseDraft().new_com_lightningkite_reactive_core_BaseDraft_vz2nwe_k$(published);
}
function Draft_0(initialValue) {
  return BaseDraft().new_com_lightningkite_reactive_core_BaseDraft_vz2nwe_k$(MutableRemember().new_com_lightningkite_reactive_core_MutableRemember_edn3s4_k$(VOID, true, VOID, VOID, initialValue));
}
var BaseDraftClass;
function BaseDraft() {
  if (BaseDraftClass === VOID) {
    class $ {
      constructor(published, buffer) {
        return new.target.new_com_lightningkite_reactive_core_BaseDraft_a71yaa_k$(published, buffer);
      }
      static new_com_lightningkite_reactive_core_BaseDraft_a71yaa_k$(published, buffer) {
        var $this = createThis(this);
        $this.published_1 = published;
        $this.buffer_1 = buffer;
        var tmp = $this;
        tmp.changesMade_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => !equals($this$remember.invoke_r7m7el_k$($this.buffer_1), $this$remember.invoke_r7m7el_k$($this.published_1)));
        return $this;
      }
      get_published_wg9pad_k$() {
        return this.published_1;
      }
      static new_com_lightningkite_reactive_core_BaseDraft_vz2nwe_k$(published) {
        return this.new_com_lightningkite_reactive_core_BaseDraft_a71yaa_k$(published, MutableRemember().new_com_lightningkite_reactive_core_MutableRemember_edn3s4_k$(false, VOID, VOID, VOID, ($this$MutableRemember) => $this$MutableRemember.invoke_r7m7el_k$(published)));
      }
      get_changesMade_d6j01d_k$() {
        return this.changesMade_1;
      }
      *publish_xq9q2e_k$($completion) {
        yield* this.published_1.set_revjhg_k$(yield* awaitOnce(this.buffer_1, $completion), $completion);
        this.buffer_1.reset_5u6xz3_k$();
        return yield* awaitOnce(this, $completion);
      }
      cancel_2l89ey_k$() {
        this.buffer_1.reset_5u6xz3_k$();
      }
      lens_drj4fu_k$(get, set) {
        return this.buffer_1.lens_drj4fu_k$(get, set);
      }
      lens_u4wb4z_k$(get, modify) {
        return this.buffer_1.lens_u4wb4z_k$(get, modify);
      }
      get_state_wc71uu_k$() {
        return this.buffer_1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.buffer_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.buffer_1.beginUse_omrbby_k$();
      }
      *set_revjhg_k$(value, $completion) {
        yield* this.buffer_1.set_revjhg_k$(value, $completion);
        return Unit_instance;
      }
      valueSet_aujvv6_k$(value) {
        this.buffer_1.valueSet_aujvv6_k$(value);
      }
    }
    initMetadataForClass($, 'BaseDraft', VOID, VOID, [MutableReactive(), MutableValue()], [0, 1]);
    BaseDraftClass = $;
  }
  return BaseDraftClass;
}
//region block: exports
export {
  Draft_0 as Draftj5auffrm1u2b,
  Draft as Draftazcheef5x425,
};
//endregion

//# sourceMappingURL=Draft.mjs.map
